<div class="card">
  <div class="card-header">
    <span class="card-title"
      >{{ resource.id ? "Edit" : "Add" }} Branchline</span
    >
  </div>
  <div class="card-body">
    <mat-form-field>
      <mat-label>Branchline Name</mat-label>
      <input
        matInput
        [(ngModel)]="branchlineName"
        placeholder="Branchline Name"
        [ngModelOptions]="{ standalone: true }"
      />
    </mat-form-field>
  </div>

  <div class="card-footer">
    <div mat-dialog-actions align="center">
      <button mat-flat-button color="warn" (click)="cancel()">Cancel</button>
      <button
        mat-flat-button
        color="primary"
        [disabled]="isSaving"
        (click)="add()"
      >
        Accept
      </button>
    </div>
  </div>
</div>
